import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'setup',
    lazy: async () => ({ Component: (await import('./SetupPage')).SetupPage }),
  },
];
